<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.email"
                    label="E-mail"
                    v-model="model.email"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.usuario"
                    label="Nome do usuário"
                    v-model="model.usuario"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    props: {
        model: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                email: {
                    required: true,
                    min: 5,
                    max: 180,
                    email: true,
                },
                usuario: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        }
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
    },
}
</script>